import React, { PureComponent } from 'react';
import Icon from '../../core/scripts/components/Icon';

class MobileTeaser extends PureComponent {
  render() {
    return (
      <div className="mobileteaser">
        <a className="mobileteaser__link" href={ARTICLE_CONFIG.teaserLink} target="_blank">
          {/* <img src="images/eu.png" className="mobileteaser__img"/> */}
          <Icon type="stats"/>
          <strong>Alle Ergebnisse</strong> für Deutschland und Europa →</a>
      </div>
    );
  }
}

export default MobileTeaser;


